<template>
  <div class="expense-warning" redesign>
    <!-- Request stepper -->
    <RequestStepProgressBar step6 />

    <div class="form-container expense-warning-form">
      <h4 v-translate>Your request is missing expense documentation.</h4>
      <p v-translate>
        Documentation is required for each expense type except food, when requesting $200 or less
        for food.
      </p>
    </div>
    <div class="button-container">
      <button class="form-button white-button" @click="handleGoBack">
        <span v-translate>Go Back</span>
      </button>

      <button class="form-button" @click="handleUploadLater">
        <span v-translate>Upload Later</span>
      </button>
    </div>
  </div>
</template>

<script>
import { analyticsMixin } from '@/services/googleAnalytics'
import RequestStepProgressBar from '@/components/stepper/RequestStepProgressBar'

export default {
  name: 'ExpenseWarning',
  components: { RequestStepProgressBar },
  mixins: [analyticsMixin],
  methods: {
    handleGoBack() {
      this.trackClickedCTA('go back')
      this.$router.push({ name: 'ExpenseDocumentation' })
    },
    handleUploadLater() {
      this.trackClickedCTA('upload later')
      this.$router.push({ name: 'RequestSummary' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.expense-warning {
  display: flex;
  flex-direction: column;

  .expense-warning-form {
    @extend .constrain-tablet-and-up;
  }
}
</style>
